import { Query } from '@skylab-shared/core';
import { ReportColumn } from '../common/report-column';


export class ReportPrintQuery<TResult extends ReportPrintResult> extends Query<TResult> {
    public constructor(public readonly parameters: ReportPrintQueryParameters) {
        super();
    }
}

export interface ReportPrintQueryParameters {
    readonly parameters: string;
    readonly summary: boolean;
    readonly columns: ReportColumn[];

    readonly compress?: boolean;
    readonly password?: string;
    readonly ecoMode: boolean;
    readonly landscape: boolean;
}

export interface ReportPrintResult {
    readonly url: string;
}
